import * as userTypes from "Store/user/constants";

const initialState: IUserReducer = {
  isLogged: false,
  user: null,
  authorizedStatus: true,
  showWelcomeModal: false,
  impersonateAvatar: null
};

const handleActions = (state, action) => {
  switch (action.type) {
    case userTypes.SET_USER_IS_LOGGED:
      return {
        isLogged: action.value
      };
    case userTypes.SET_CURRENT_USER:
      return {
        user: action.user
      };
    case userTypes.SET_AUTHORIZED_STATUS:
      return {
        authorizedStatus: action.status
      };
    case userTypes.SET_USER_AVATAR:
      return {
        user: { ...state.user, avatar: action.avatar }
      };

    case userTypes.SHOW_WELCOME_MODAL:
      return {
        showWelcomeModal: action.toggle
      };

    default:
      return {};
  }
};

const userReducer = (state = initialState, action) => ({
  ...state,
  ...handleActions(state, action)
});

export default userReducer;
